import { render, staticRenderFns } from "./AdminBar.vue?vue&type=template&id=e8d9f1f6"
import script from "./AdminBar.vue?vue&type=script&lang=js"
export * from "./AdminBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8d9f1f6')) {
      api.createRecord('e8d9f1f6', component.options)
    } else {
      api.reload('e8d9f1f6', component.options)
    }
    module.hot.accept("./AdminBar.vue?vue&type=template&id=e8d9f1f6", function () {
      api.rerender('e8d9f1f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/AdminBar.vue"
export default component.exports